import { Item, Vendor } from "src/app/shared/models/database-models/SaveMyPurchase.model"

export interface RfsSourcingResponse {
    outcome: RfsOutcome
    wocItems: string[] | null
    priceAgreementItems: string[] | null
    smlItems: string[] | null
    emptyVendors: string[] | null
    deactivatedItemList: Item[] | null
    deactivatedVendorList: Vendor[] | null
}
export enum RfsOutcome {
    success = 'success',
    partial = 'partial',
    unsuccessful = 'failure'
}